module.exports = __webpack_public_path__ + "img/upload-active.a15efafc.svg";